export default __webpack_public_path__ + "static/media/kitbox.d34eec57.png";